import api from "@/service/Api/Api";
import { apiResponse } from "@/service/Api/Api";

export interface deleteAdministratorRequest {}

export interface deleteAdministratorResponse {}

export default {
  deleteAdministrator(
    data: deleteAdministratorRequest,
    volumeLicenseId: string,
    administratorId: string
  ): Promise<deleteAdministratorResponse & apiResponse> {
    return api<deleteAdministratorRequest, deleteAdministratorResponse>({
      endpoint:
        "volume-licenses/" +
        volumeLicenseId +
        "/administrators/web-api/" +
        administratorId,
      method: "DELETE",
      body: data,
    });
  },
};
